import { SVGProps } from 'react';
import { twMerge } from 'tailwind-merge';

export default function Close(props: Partial<SVGProps<any>>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="84" height="84" viewBox="0 0 84 84" fill="none" preserveAspectRatio='none' {...props} className={twMerge('[&>path]:fill-primary-300 dark:[&>path]:fill-white' ,props.className)}>
      <path d="M19.3733 69.6692C20.5448 70.8407 22.4443 70.8407 23.6159 69.6692L63.921 29.3641C65.0926 28.1925 65.0926 26.293 63.921 25.1214C62.7494 23.9499 60.8499 23.9499 59.6784 25.1214L19.3733 65.4265C18.2017 66.5981 18.2017 68.4976 19.3733 69.6692Z" />
      <path d="M60.3849 69.669L20.0799 29.364C18.9083 28.1924 18.9083 26.2929 20.0799 25.1213C21.2514 23.9497 23.1509 23.9497 24.3225 25.1213L64.6276 65.4264C65.7992 66.598 65.7992 68.4975 64.6276 69.669C63.456 70.8406 61.5565 70.8406 60.3849 69.669Z" />
    </svg>
  )
}